import { AiOutlineCheck } from "react-icons/ai";
import "./Connector.css";

const Connector = ({ activeStep }: { activeStep: number }) => {
  return (
    <div
      style={{
        backgroundColor: "#F5F9FD",
      }}
    >
      <div
        className="grid-container hide-for-small-only"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: 45,
          paddingBottom: 24,
        }}
      >
        <div className="connected-steps">
          <div>
            <div
              className={`step ${activeStep === 1 ? "active" : ""}`}
              style={{
                borderColor:
                  activeStep === 2 || activeStep === 3 ? "#0065F2" : "",
                color: activeStep === 2 || activeStep === 3 ? "#0065F2" : "",
              }}
            >
              {activeStep === 2 || activeStep === 3 ? (
                <AiOutlineCheck size={25} />
              ) : (
                "1"
              )}
            </div>
          </div>

          <div className="connector"></div>
          <div>
            <div
              className={`step ${activeStep === 2 ? "active" : ""}`}
              style={{
                borderColor: activeStep === 3 ? "#0065F2" : "",
                color: activeStep === 3 ? "#0065F2" : "",
              }}
            >
              {activeStep === 3 ? <AiOutlineCheck size={25} /> : "2"}
            </div>
          </div>

          <div className="connector"></div>
          <div>
            <div className={`step ${activeStep === 3 ? "active" : ""}`}>3</div>
          </div>
        </div>
        <div className="connected-steps" style={{ paddingTop: 10 }}>
          <div>
            <div className={`stepword ${activeStep === 1 ? "active" : ""}`}>
              Coverage
            </div>
          </div>

          <div className="connectorword"></div>
          <div>
            <div className={`stepword ${activeStep === 2 ? "active" : ""}`}>
              Preferences
            </div>
          </div>

          <div className="connectorword"></div>
          <div>
            <div className={`stepword ${activeStep === 3 ? "active" : ""}`}>
              Doctors
            </div>
          </div>
        </div>
      </div>
      <div
        className="grid-container show-for-small-only"
        style={{
          display: "flex",
          flexDirection: "column",
          paddingTop: 45,
          paddingBottom: 28,
        }}
      >
        <div
          style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
          className="connected-steps"
        >
          <div>
            <div
              className={`step ${activeStep === 1 ? "active" : ""}`}
              style={{
                borderColor:
                  activeStep === 2 || activeStep === 3 ? "#0065F2" : "",
                color: activeStep === 2 || activeStep === 3 ? "#0065F2" : "",
              }}
            >
              {activeStep === 2 || activeStep === 3 ? (
                <AiOutlineCheck size={25} />
              ) : (
                "1"
              )}
            </div>
          </div>

          <div className="connector"></div>
          <div>
            <div
              className={`step ${activeStep === 2 ? "active" : ""}`}
              style={{
                borderColor: activeStep === 3 ? "#0065F2" : "",
                color: activeStep === 3 ? "#0065F2" : "",
              }}
            >
              {activeStep === 3 ? <AiOutlineCheck size={25} /> : "2"}
            </div>
          </div>

          <div className="connector"></div>
          <div>
            <div className={`step ${activeStep === 3 ? "active" : ""}`}>3</div>
          </div>
        </div>
        <div
          className="connected-steps"
          style={{
            paddingTop: 10,
            width: "100%",
            paddingLeft: 20,
            paddingRight: 20,
          }}
        >
          <div>
            <div className={`stepword ${activeStep === 1 ? "active" : ""}`}>
              Coverage
            </div>
          </div>

          <div className="connectorword"></div>
          <div>
            <div className={`stepword ${activeStep === 2 ? "active" : ""}`}>
              Preferences
            </div>
          </div>

          <div className="connectorword"></div>
          <div>
            <div className={`stepword ${activeStep === 3 ? "active" : ""}`}>
              Doctors
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Connector;
